export var single = [
    {
      "name": "Germany",
      "value": 8940000
    },
    {
      "name": "USA",
      "value": 5000000
    },
    {
      "name": "France",
      "value": 7200000
    }
  ];
  
  export var multi = [
    {
      "name": "Germany",
      "series": [
        {
          "name": "2010",
          "value": 7300000
        },
        {
          "name": "2011",
          "value": 8940000
        }
      ]
    },
  
    {
      "name": "USA",
      "series": [
        {
          "name": "2010",
          "value": 7870000
        },
        {
          "name": "2011",
          "value": 8270000
        }
      ]
    },
  
    {
      "name": "France",
      "series": [
        {
          "name": "2010",
          "value": 5000002
        },
        {
          "name": "2011",
          "value": 5800000
        }
      ]
    }
  ];

  export var unattended = [
    {
      "name": "Clinic A",
      "series": [
        {
          "value": 40,
          "name": "2018-09-02T15:51:46.031Z"
        },
        {
          "value": 50,
          "name": "2018-09-23T20:13:02.801Z"
        },
        {
          "value": 45,
          "name": "2018-09-23T16:29:17.812Z"
        },
        {
          "value": 52,
          "name": "2018-09-13T21:55:05.495Z"
        },
        {
          "value": 23,
          "name": "2018-09-18T06:47:49.387Z"
        }
      ]
    },
    {
      "name": "Clinic B",
      "series": [
        {
          "value": 29,
          "name": "2018-09-02T15:51:46.031Z"
        },
        {
          "value": 24,
          "name": "2018-09-23T20:13:02.801Z"
        },
        {
          "value": 58,
          "name": "2018-09-23T16:29:17.812Z"
        },
        {
          "value": 68,
          "name": "2018-09-13T21:55:05.495Z"
        },
        {
          "value": 65,
          "name": "2018-09-18T06:47:49.387Z"
        }
      ]
    },
    {
      "name": "Clinic C",
      "series": [
        {
          "value": 48,
          "name": "2018-09-02T15:51:46.031Z"
        },
        {
          "value": 48,
          "name": "2018-09-23T20:13:02.801Z"
        },
        {
          "value": 66,
          "name": "2018-09-23T16:29:17.812Z"
        },
        {
          "value": 64,
          "name": "2018-09-13T21:55:05.495Z"
        },
        {
          "value": 31,
          "name": "2018-09-18T06:47:49.387Z"
        }
      ]
    },
    {
      "name": "Clinic D",
      "series": [
        {
          "value": 31,
          "name": "2018-09-02T15:51:46.031Z"
        },
        {
          "value": 49,
          "name": "2018-09-23T20:13:02.801Z"
        },
        {
          "value": 35,
          "name": "2018-09-23T16:29:17.812Z"
        },
        {
          "value": 31,
          "name": "2018-09-13T21:55:05.495Z"
        },
        {
          "value": 52,
          "name": "2018-09-18T06:47:49.387Z"
        }
      ]
    },
    {
      "name": "Clinic E",
      "series": [
        {
          "value": 52,
          "name": "2018-09-02T15:51:46.031Z"
        },
        {
          "value": 20,
          "name": "2018-09-23T20:13:02.801Z"
        },
        {
          "value": 32,
          "name": "2018-09-23T16:29:17.812Z"
        },
        {
          "value": 61,
          "name": "2018-09-13T21:55:05.495Z"
        },
        {
          "value": 34,
          "name": "2018-09-18T06:47:49.387Z"
        }
      ]
    }
  ];

  export var unattended1 = [
        { 
          clinic: "Clinic A",
          Value: 40,
          name: "2018-09-02T15:51:46.031Z"
        },
        {
          clinic: "Clinic A",
          Value: 50,
          name: "2018-09-23T20:13:02.801Z"
        },
        {
          clinic: "Clinic A",  
          Value: 45,
          name: "2018-09-23T16:29:17.812Z"
        },
        {
          clinic: "Clinic A",
          Value: 52,
          name: "2018-09-13T21:55:05.495Z"
        },
        {
          clinic: "Clinic A",  
          Value: 23,
          name: "2018-09-18T06:47:49.387Z"
        },
        {  
          clinic: "Clinic B",
          Value: 29,
          name: "2018-09-02T15:51:46.031Z"
        },
        {
          clinic: "Clinic B",
          Value: 24,
          name: "2018-09-23T20:13:02.801Z"
        },
        {
          clinic: "Clinic B",
          Value: 58,
          name: "2018-09-23T16:29:17.812Z"
        },
        {
          clinic: "Clinic B",
          Value: 68,
          name: "2018-09-13T21:55:05.495Z"
        },
        {
          clinic: "Clinic B",
          Value: 65,
          name: "2018-09-18T06:47:49.387Z"
        },   
        {
          clinic: "Clinic C",
          Value: 48,
          name: "2018-09-02T15:51:46.031Z"
        },
        {
          clinic: "Clinic C",
          Value: 48,
          name: "2018-09-23T20:13:02.801Z"
        },
        {
          clinic: "Clinic C",
          Value: 66,
          name: "2018-09-23T16:29:17.812Z"
        },
        {
          clinic: "Clinic C",
          Value: 64,
          name: "2018-09-13T21:55:05.495Z"
        },
        {
          clinic: "Clinic C",
          Value: 31,
          name: "2018-09-18T06:47:49.387Z"
        },     
        {
          clinic: "Clinic D",
          Value: 31,
          name: "2018-09-02T15:51:46.031Z"
        },
        {
          clinic: "Clinic D",
          Value: 49,
          name: "2018-09-23T20:13:02.801Z"
        },
        {
          clinic: "Clinic D",
          Value: 35,
          name: "2018-09-23T16:29:17.812Z"
        },
        {
          clinic: "Clinic D",
          Value: 31,
          name: "2018-09-13T21:55:05.495Z"
        },
        {
          clinic: "Clinic D",
          Value: 52,
          name: "2018-09-18T06:47:49.387Z"
        }     
    ];
 

    export var messages = [
      { 
        type: "SMS",
        Value: 40,
        date: "2018-09-02T15:51:46.031Z"
      },
      {
        type: "SMS",
        Value: 50,
        date: "2018-09-23T20:13:02.801Z"
      },
      {
        type: "SMS",  
        Value: 45,
        date: "2018-09-23T16:29:17.812Z"
      },
      {
        type: "SMS",
        Value: 52,
        date: "2018-09-13T21:55:05.495Z"
      },
      {
        type: "SMS",  
        Value: 23,
        date: "2018-09-18T06:47:49.387Z"
      },
      {  
        type: "email",
        Value: 29,
        date: "2018-09-02T15:51:46.031Z"
      },
      {
        type: "email",
        Value: 24,
        date: "2018-09-23T20:13:02.801Z"
      },
      {
        type: "email",
        Value: 58,
        date: "2018-09-23T16:29:17.812Z"
      },
      {
        type: "email",
        Value: 68,
        date: "2018-09-13T21:55:05.495Z"
      },
      {
        type: "email",
        Value: 65,
        date: "2018-09-18T06:47:49.387Z"
      }
  ];
  